import { type FC, useState } from 'react';

import {
  PackImageContainer,
  PackStickerWrapper,
  StickerContent,
  CreatorContainer,
  TitleContainer,
  Text,
  Image,
} from './styled';
import Sticker from '../Sticker';
import { packImages } from '../helpers';

type PackImageProps = {
  creator: string,
  title: string,
  type: string,
  isWithBackground?: boolean,
  'data-test-id'?: string,
};

const PackImage: FC<PackImageProps> = ({
  creator,
  title,
  type = 'common',
  isWithBackground,
  'data-test-id': dataTestId,
}) => {
  const [isImgLoaded, setIsImageLoaded] = useState<boolean>(false);

  const onLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <PackImageContainer>
      {isImgLoaded && (
        <PackStickerWrapper isWithBackground={isWithBackground}>
          <Sticker />
          <StickerContent>
            <CreatorContainer>
              <Text>{creator}</Text>
            </CreatorContainer>
            <TitleContainer>
              <Text>{title}</Text>
            </TitleContainer>
          </StickerContent>
        </PackStickerWrapper>
      )}
      <Image
        onLoad={onLoad}
        src={
          isWithBackground
            ? packImages[type].withBackground.src
            : packImages[type].withoutBackground.src
        }
        srcSet={
          isWithBackground
            ? packImages[type].withBackground.srcset
            : packImages[type].withoutBackground.srcset
        }
        data-test-id={dataTestId}
      />
    </PackImageContainer>
  );
};

export default PackImage;
